import { storage } from "modules/storage";

const DEVICE_OPT_OUT_KEY = "adTrackingOptOut";

/** A browser that sends Global Privacy Control has already opted out of advertising trackers. */
export function hasGlobalPrivacyControl(): boolean {
  return (
    (globalThis.navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl === true
  );
}

/** The choice made on this device, which also covers a visitor who is signed out. */
export function getDeviceAdTrackingOptOut(): boolean {
  return storage.getItem(DEVICE_OPT_OUT_KEY) === "true";
}

export function setDeviceAdTrackingOptOut(optOut: boolean): void {
  if (optOut) storage.setItem(DEVICE_OPT_OUT_KEY, "true");
  else storage.removeItem(DEVICE_OPT_OUT_KEY);
}

/** Resolves once the device choice is saved, so the app can be reloaded without losing it. */
export function whenDeviceAdTrackingOptOutPersisted(): Promise<void> {
  return storage.whenPersisted(DEVICE_OPT_OUT_KEY);
}

/** Advertising trackers stay off when either the device choice or the browser signal says so. */
export function hasOptedOutOfAdTracking(): boolean {
  return hasGlobalPrivacyControl() || getDeviceAdTrackingOptOut();
}

/** Whether the practice has any advertising tag set up, so there is something to opt out of. */
export function hasConfiguredAdTracking(
  adTracking: { metaPixelId?: string | null; googleAdsId?: string | null } | null | undefined,
): boolean {
  return [adTracking?.metaPixelId, adTracking?.googleAdsId].some(
    (id) => id !== null && id !== undefined && id.trim() !== "",
  );
}
